import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import Gallery from './components/Gallery';
import Reviews from './components/Reviews';
import BookingSection from './components/BookingSection';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminReviews from './pages/AdminReviews';
import AdminBookings from './pages/AdminBookings';
import AdminContent from './pages/AdminContent';
import './App.css';

const HomePage = () => {
  return (
    <>
      <Header />
      <Hero />
      <Gallery />
      <BookingSection />
      <Reviews />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/reviews" element={<AdminReviews />} />
          <Route path="/admin/bookings" element={<AdminBookings />} />
          <Route path="/admin/content" element={<AdminContent />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
